<template>
  <vs-popup
    class="holamundo attendee-seetings-popup attendee-seetingpage-popup"
    title="Attendee - Advanced Settings"
    :active.sync="popupActive2"
  >
    <ul class="option-inner-wrap mb-5">
      <li class="mb-4">
        <label for>Allow Meeting Requests</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/allow-meeting-request.jpg"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.ShowMeetingButton" />
        </div>
      </li>
      <li class="mb-4">
        <label for>Show Filter</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/attendee-filter.jpg"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.ShowFilter" />
        </div>
      </li>
      <li class="mb-4">
        <label for>Show Send Message Button</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/allow-msg-request.jpg"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.ShowSendMessageButton" />
        </div>
      </li>
      <li class="mb-4">
        <label for>Show Search</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/show-attendee-search.jpg"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.ShowSearch" />
        </div>
      </li>
      <li class="mb-4">
        <label for>Enable Attendee Search</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/show-attendee-search.jpg"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.EnableAttendeeDBsearch" />
        </div>
      </li>
      <li class="mb-4">
        <label for>Show Email and Phone</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/attendee-phone-email.jpg"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.ShowEmailandPhone" />
        </div>
      </li>
      <li class="mb-4">
        <label for>Show Legend</label>
        <div class="popup-single-upload-right">
          <div class="info-option-wrapper">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="popup-info-tooltips">
              <img
                src="../../assets/images/attendee-settings-show-legend.png"
                alt="Display"
              />
            </div>
          </div>
          <vs-switch v-model="settingsData.ShowLegend" />
        </div>
      </li>
      <li class="mb-4">
        <label for>Attendee List Sort By</label>
        <div class="popup-single-upload-right">
          <vs-radio
            v-model="settingsData.AttendeeListSortBy"
            vs-value="FirstName"
            name="AttendeeListSortBy"
            >FirstName</vs-radio
          >
          <vs-radio
            class="ml-3"
            v-model="settingsData.AttendeeListSortBy"
            vs-value="LastName"
            name="AttendeeListSortBy"
            >LastName</vs-radio
          >
        </div>
      </li>
    </ul>
    <vs-button color="rgb(76, 139, 246)" type="filled" class="sub-btn" v-on:click="saveSettings"
      >Save</vs-button
    >
  </vs-popup>
</template>
<script>
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
export default {
  components: {},
  props: {
    data: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      settingsData: { ShowMeetingButton: false },
      popupActive2: this.data,
      IsDefaultSettings: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    getDefaultSettings() {
      this.IsDefaultSettings = true;
      this.settingsData = {
        AttendeeListSortBy: "FirstName",
        EnableAttendeeDBsearch: true,
        ShowEmailandPhone: true,
        ShowFilter: true,
        ShowLegend: false,
        ShowMeetingButton: true,
        ShowSearch: true,
        ShowSendMessageButton: true,
      };
      this.popupActive2 = true;
    },
    getSettings() {
      this.$vs.loading();
      this.IsDefaultSettings = false;
      this.$store.dispatch("attendeeManagement/getSettings").then((res) => {
        this.settingsData = res;
        this.settingsData.AttendeeListSortBy = res.AttendeeListSortBy
          ? res.AttendeeListSortBy
          : "FirstName";
        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    saveSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("attendeeManagement/saveSettings", {
          settingsData: this.settingsData,
          IsDefaultSettings: this.IsDefaultSettings,
        })
        .then((res) => {
          this.popupActive2 = false;
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
           this.$emit('saveSettingsData')
          //this.IsDefaultSettings = false;
          this.$vs.loading.close();
        });
    },
  },
  mounted() {},
  created() {
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }

    this.$store.dispatch("attendeeManagement/getSettings").then((res) => {
      console.log("res========",res);
      this.settingsData = res;
      if(this.settingsData.AttendeeListSortBy == null){
        this.getDefaultSettings();
      }
    });
  },
};
</script>

